import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
  import { FacadeInterface } from "@/types/FacadeInterface";
  import { ref, onMounted, watch } from "vue";
  import { useToast } from "vue-toastification";
  import FacadeItemCard from "./FacadeItemCard.vue";
  import ConfirmDeleteModal from "@/components/ui/modals/ConfirmDeleteModal.vue";
  import UpdateFacadeInGalleryModal from "@/components/ui/modals/UpdateFacadeInGalleryModal.vue";

  type Props = {
    builderId: string;
    reload: boolean;
  };
  
export default /*@__PURE__*/_defineComponent({
  __name: 'FacadeGallery',
  props: {
    builderId: {},
    reload: { type: Boolean }
  },
  emits: ["openModal", "setReload", "updateFacade"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;
  const toast = useToast();

  const facades = ref<FacadeInterface[]>([]);
  const isLoading = ref(true);
  const isConfirmDeleteFacadeModalOpen = ref(false);
  const facadeDelete = ref<FacadeInterface | null>(null);

  const openModal = () => emits("openModal");

  const getFacades = async () => {
    try {
      isLoading.value = true;
      const data = await store.dispatch("facade/getFacadesByQuery", {
        builderId: props.builderId.toString(),
      });

      facades.value = data;
    } catch (error) {
      toast.error("An error occurred while getting the facades");
    } finally {
      isLoading.value = false;
    }
  };

  const updateFacade = (facade: FacadeInterface) => {
    emits("updateFacade", facade);
  };

  const confirmDelete = (facade: FacadeInterface) => {
    facadeDelete.value = facade;
    isConfirmDeleteFacadeModalOpen.value = true;
  };

  const deleteFacade = async (facade: FacadeInterface) => {
    try {
      isLoading.value = true;
      await store.dispatch("facade/deleteFacade", {
        id: facade._id,
      });
      facadeDelete.value = null;
      await getFacades();
    } catch (error) {
      toast.error(
        `An error occurred while deleting the facade ${facade?.name}`
      );
    } finally {
      isLoading.value = false;
    }
  };

  onMounted(() => getFacades());

  watch(
    () => props.builderId,
    () => getFacades()
  );

  watch(
    () => props.reload,
    () => {
      if (!props.reload) return;

      getFacades();
      emits("setReload");
    }
  );

const __returned__ = { emits, props, toast, facades, isLoading, isConfirmDeleteFacadeModalOpen, facadeDelete, openModal, getFacades, updateFacade, confirmDelete, deleteFacade, get store() { return store }, get FacadeInterface() { return FacadeInterface }, ref, onMounted, watch, get useToast() { return useToast }, FacadeItemCard, ConfirmDeleteModal, UpdateFacadeInGalleryModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})